/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_6_Paragraphs_0Inputs */

const en_gc_search_guides_gridcraft_online_sections_6_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_6_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If the application fails before a sample grid appears, begin with the browser environment. Confirm that the connection can load the application, check the displayed error, and use the offered WebGL fallback if appropriate. Retrying with a small sample is more informative than repeatedly opening a complex workbook while the graphics runtime itself is not starting. The fallback is a renderer choice, not a repair tool for workbook data.`)
};

const zh_gc_search_guides_gridcraft_online_sections_6_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_6_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果示例网格出现之前应用就失败，应先检查浏览器环境。确认网络可以加载应用，查看错误信息，并在适用时使用页面提供的 WebGL 备用入口。在图形运行环境尚未启动的情况下，反复打开复杂工作簿意义不大。备用入口只是选择渲染方式，不是修复工作簿数据的工具。`)
};

/**
* | output |
* | --- |
* | "If the application fails before a sample grid appears, begin with the browser environment. Confirm that the connection can load the application, check the di..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_6_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_6_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_6_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_6_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_6_paragraphs_0(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_6_paragraphs_0(inputs)
});
export { gc_search_guides_gridcraft_online_sections_6_paragraphs_0 as "gc.search_guides.gridcraft_online.sections.6.paragraphs.0" }